export default __webpack_public_path__ + "static/hclp-658f721970d9a8ed783228e977e8933e.png";